/**
 * useViewPreference.js
 * Hook para guardar y recuperar la preferencia de vista del usuario
 */
import { useState, useEffect } from "react";

const STORAGE_KEY_PREFIX = "view_preference_";

export default function useViewPreference(pageKey, defaultView = "table") {
  // Get initial value from localStorage or use default
  const getInitialView = () => {
    try {
      const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${pageKey}`);
      return stored || defaultView;
    } catch (e) {
      console.warn("Could not access localStorage:", e);
      return defaultView;
    }
  };

  const [view, setView] = useState(getInitialView);

  // Save to localStorage when view changes
  const setViewWithStorage = (newView) => {
    setView(newView);
    try {
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${pageKey}`, newView);
    } catch (e) {
      console.warn("Could not save view preference:", e);
    }
  };

  return [view, setViewWithStorage];
}

// Helper function to get all saved view preferences (for debugging)
export function getAllViewPreferences() {
  const preferences = {};
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(STORAGE_KEY_PREFIX)) {
        const pageKey = key.replace(STORAGE_KEY_PREFIX, "");
        preferences[pageKey] = localStorage.getItem(key);
      }
    }
  } catch (e) {
    console.warn("Could not read view preferences:", e);
  }
  return preferences;
}

// Helper function to clear all view preferences
export function clearAllViewPreferences() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(STORAGE_KEY_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    return true;
  } catch (e) {
    console.warn("Could not clear view preferences:", e);
    return false;
  }
}
